// Ouvrir un document autonome et l'imprimer.
//
// Les papiers d'entreprise (apports, et demain d'autres) sont des documents HTML
// complets qui portent leur propre feuille de style et appellent window.print()
// au chargement — c'est le mécanisme de la V2, conservé tel quel. Il n'y a donc
// rien à convertir : on ouvre une fenêtre et on lui donne le document.

export type ResultatImpression = 'ok' | 'bloque'

/**
 * @returns 'bloque' si le navigateur a refusé la fenêtre — le seul échec
 *   possible, et il faut le dire à l'opérateur plutôt que de ne rien faire.
 */
export function imprimerDocument(html: string, titre: string): ResultatImpression {
  // Surtout PAS `noopener` : la spécification impose alors à window.open de
  // renvoyer `null`, et il n'y a plus rien où écrire le document. On croyait la
  // fenêtre bloquée alors qu'elle s'ouvrait — vide.
  const fenetre = window.open('', '_blank', 'width=1180,height=860')
  if (!fenetre) return 'bloque'
  fenetre.document.open()
  fenetre.document.write(html)
  fenetre.document.close()
  try { fenetre.document.title = titre } catch { /* même origine attendue, sans conséquence */ }
  return 'ok'
}
